import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";

/**
 * What a coach, an athlete or a parent is told when their club's trial ran out.
 *
 * They did nothing wrong and can do nothing about it, so the message says both:
 * everything they can see is still theirs, and the club is the one that has to
 * act. Without it, a coach taps "salvează prezența", nothing happens, and they
 * conclude the app is broken.
 *
 * Deliberately a quiet strip rather than a blocking dialog — they are in the
 * middle of a training session, not in a billing conversation.
 */
export default function ClubPausedNotice() {
  const { t } = useTranslation();
  const { clubAccess, activeRole } = useAuth();

  if (!clubAccess || clubAccess.state !== "locked") return null;
  // The club admin has their own, fuller version of this with the way out.
  if (activeRole === "club_admin" || activeRole === "coordinator") return null;

  return (
    <div className="px-4 py-3 mx-4 mt-3 border bg-amber-50 border-amber-200 rounded-xl">
      <div className="flex items-start gap-2.5">
        <svg
          className="w-5 h-5 mt-0.5 text-amber-600 shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.8}
            d="M12 9v3m0 3h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
          />
        </svg>
        <div className="min-w-0">
          <p className="text-sm font-bold text-amber-900">
            {t("trial.memberTitle", "Clubul este în pauză")}
          </p>
          <p className="mt-0.5 text-xs leading-relaxed text-amber-800">
            {t("trial.memberBody", {
              defaultValue:
                "{{club}} are perioada de probă încheiată. Vezi în continuare tot ce există — antrenamente, prezențe, puncte — dar nu se poate înregistra nimic nou până când clubul activează planul Baza.",
              club: clubAccess.clubName,
            })}
          </p>
        </div>
      </div>
    </div>
  );
}
